import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import { delayedDataLayerPush } from './DataLayer';

type ProductForGA4 = {
  item_id: string,
  item_name: string,
  price: number,
};

export default function productList(id: string, name: string) {
  return {
    id,
    name,
    sentData: new Array<string>(),
    itemCount: 0,
    init() {
      this.initSwiper();
      // @ts-ignore
      this.itemCount = this.$el.querySelectorAll('.ga-trackable').length;
      this.checkWhatIsViewed();
      window.addEventListener('scroll', () => { this.checkWhatIsViewed(); });
    },
    initSwiper() {
      if (this.name !== 'featured_products') {
        if (this.name === 'quickLinks') {
          // @ts-ignore
          this.$el.querySelectorAll('.swiper-quicklinks-wrap').forEach(($holder: HTMLElement) => {
            const $mainSwiper = $holder.querySelector('.swiper-quicklinks') as HTMLElement;
            const $navNext = $holder.querySelector('.swiper-nav .swiper-button-next') as HTMLElement;
            const $navPrev = $holder.querySelector('.swiper-nav .swiper-button-prev') as HTMLElement;
            const shouldInitialize = !!($mainSwiper && $navNext && $navPrev)
              && !$mainSwiper.classList.contains('swiper-initialized');

            if (!shouldInitialize) {
              return;
            }

            const slider = new Swiper($mainSwiper, {
              modules: [Navigation],
              slidesPerView: 'auto',
              grabCursor: true,
              spaceBetween: 16,
              navigation: {
                nextEl: $navNext,
                prevEl: $navPrev,
              },
              breakpoints: {
                1024: {
                  slidesPerView: 6,
                  spaceBetween: 30,
                  cssMode: false,
                },
              },
            });
            slider.on('sliderMove', () => {
              this.checkWhatIsViewed();
            });
            slider.on('slideChangeTransitionEnd', () => {
              this.checkWhatIsViewed();
            });
          });
        } else {
          // @ts-ignore
          this.$el.querySelectorAll('.swiper-product-wrap').forEach(($holder: HTMLElement) => {
            const $mainSwiper = $holder.querySelector('.swiper-product') as HTMLElement;
            const $navNext = $holder.querySelector('.swiper-nav .swiper-button-next') as HTMLElement;
            const $navPrev = $holder.querySelector('.swiper-nav .swiper-button-prev') as HTMLElement;
            const shouldInitialize = !!($mainSwiper && $navNext && $navPrev)
              && !$mainSwiper.classList.contains('swiper-initialized');

            if (!shouldInitialize) {
              return;
            }
            const slider = new Swiper($mainSwiper, {
              modules: [Navigation],
              slidesPerView: 'auto',
              grabCursor: true,
              spaceBetween: 16,
              navigation: {
                nextEl: $navNext,
                prevEl: $navPrev,
              },
              breakpoints: {
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                  cssMode: false,
                },
              },
            });

            slider.on('sliderMove', () => {
              this.checkWhatIsViewed();
            });
            slider.on('slideChangeTransitionEnd', () => {
              this.checkWhatIsViewed();
            });
          });
        }
      }
    },
    checkWhatIsViewed() {
      if (this.sentData.length < this.itemCount) {
        const data = new Array<ProductForGA4>();
        // @ts-ignore
        this.$el.querySelectorAll('.ga-trackable').forEach<HTMLElement>((item: HTMLElement) => {
          if (this.isVisibleInViewport(item)) {
            const { ga } = item.dataset;
            if (ga) {
              const gaData = JSON.parse(ga) as ProductForGA4;
              if (gaData && !this.sentData.includes(gaData.item_id)) {
                this.sentData.push(gaData.item_id);
                data.push(gaData);
              }
            }
          }
        });
        this.sendData(data);
      }
    },
    isVisibleInViewport(element: HTMLElement) {
      const rect = element.getBoundingClientRect();
      return (
        rect.top >= 0
        && rect.left >= 0
        && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
        && rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    },
    sendData(data: ProductForGA4[]) {
      if (data.length > 0) {
        delayedDataLayerPush({
          event: 'view_item_list',
          ecommerce: {
            item_list_id: this.id,
            item_list_name: this.name,
            items: data,
          },
          event_timeout: 1000,
        });
      }
    },
  };
}
